import React, { useContext, useEffect, useState } from 'react';
import Modal from 'modules/common/components/Modal';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import _ from 'lodash';
import { ModalContext } from 'App';
import * as actions from '../action';
import * as c from '../constant';
import InformationTab from './components/InformationTab';
import PropertyLocationTab from './components/PropertyLocationTab';
import AppraisalTab from './components/AppraisalTab';
import PropertyAssessmentTab from './components/PropertyAssessmentTab';
import SupersededAssessmentTab from './components/SupersededAssessmentTab';
import TransactionTab from './components/TransactionTab';

function ViewHistoryModal({
  applicationId,
  historyId,
  getSingleHistory,
  singleHistoryData,
}) {
  const setModal = useContext(ModalContext);
  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const [activeTab, setActiveTab] = useState(1);
  const [formData, setFormData] = useState({
    scroll: 0,
  });
  const scrollref = React.createRef();

  const handleActivePage = (index) => () => {
    setActiveTab(index);
  };

  const scrollToLeft = (e) => {
    e.preventDefault();
    const width = scrollref.current.scrollWidth;
    const slide = width / 15;
    const val = formData.scroll - slide < 0 ? 0 : formData.scroll - slide;
    scrollref.current.scrollLeft = val;
    setFormData({
      scroll: val,
      totalwidth: width,
      rightdistance:
        scrollref.current.offsetWidth + scrollref.current.scrollLeft,
    });
  };

  const scrollToRight = (e) => {
    e.preventDefault();

    const width = scrollref.current.scrollWidth;
    const slide = width / 15;
    const calculatedWidth = width - slide;
    const val =
      formData.scroll + slide > calculatedWidth
        ? calculatedWidth
        : formData.scroll + slide;
    scrollref.current.scrollLeft = val;
    setFormData({
      scroll: val,
      totalwidth: width,
      rightdistance:
        scrollref.current.offsetWidth + scrollref.current.scrollLeft,
    });
  };

  useEffect(() => {
    if (historyId) {
      getSingleHistory(applicationId, historyId);
    }
  }, [historyId]);

  return (
    <Modal.Body>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          marginBottom: '20px',
        }}
      >
        <div className="mb-3">
          {!_.isEmpty(singleHistoryData) ? (
            <>
              <div className="page-submenu d-flex justify-content-between align-content-center">
                <button
                  type="button"
                  className="tab-arrow left"
                  onClick={scrollToLeft}
                >
                  <div
                    style={{ cursor: 'pointer' }}
                    className={`fa fa-caret-left ${
                      +formData.scroll === 0 ? 'd-none' : ''
                    }`}
                  />
                </button>
                <ul
                  className="tab-list tab-scroll no-border scroll"
                  ref={scrollref}
                >
                  <li className="tab-item">
                    <button
                      type="button"
                      className={`btn-blank py-2 px-3 ${
                        activeTab === 1 ? 'active' : ''
                      }`}
                      onClick={handleActivePage(1)}
                    >
                      Information
                    </button>
                  </li>
                  <li className="tab-item">
                    <button
                      type="button"
                      className={`btn-blank py-2 px-3 ${
                        activeTab === 2 ? 'active' : ''
                      }`}
                      onClick={handleActivePage(2)}
                    >
                      Property Location
                    </button>
                  </li>
                  <li className="tab-item">
                    <button
                      type="button"
                      className={`btn-blank py-2 px-3 ${
                        activeTab === 3 ? 'active' : ''
                      }`}
                      onClick={handleActivePage(3)}
                    >
                      Machinery Appraisal
                    </button>
                  </li>
                  <li className="tab-item">
                    <button
                      type="button"
                      className={`btn-blank py-2 px-3 ${
                        activeTab === 4 ? 'active' : ''
                      }`}
                      onClick={handleActivePage(4)}
                    >
                      Property Assessment
                    </button>
                  </li>
                  <li className="tab-item">
                    <button
                      type="button"
                      className={`btn-blank py-2 px-3 ${
                        activeTab === 5 ? 'active' : ''
                      }`}
                      onClick={handleActivePage(5)}
                    >
                      Superseded Assessment
                    </button>
                  </li>
                  <li className="tab-item">
                    <button
                      type="button"
                      className={`btn-blank py-2 px-3 ${
                        activeTab === 6 ? 'active' : ''
                      }`}
                      onClick={handleActivePage(6)}
                    >
                      Transaction
                    </button>
                  </li>
                </ul>
                <button
                  type="button"
                  className="tab-arrow right"
                  onClick={scrollToRight}
                >
                  <div
                    style={{ cursor: 'pointer' }}
                    className={`fa fa-caret-right ${
                      +formData.totalwidth === +formData.rightdistance
                        ? 'd-none'
                        : ''
                    }`}
                  />
                </button>
              </div>
              <div className="tabs-details-modal">
                {activeTab === 1 && (
                  <InformationTab
                    data={{
                      ...singleHistoryData,
                      rptax_machinery_application_id: `${singleHistoryData?.rptax_machinery_application_id}`,
                    }}
                  />
                )}
                {activeTab === 2 && (
                  <PropertyLocationTab
                    data={{
                      ...singleHistoryData,
                      rptax_machinery_application_id: `${singleHistoryData?.rptax_machinery_application_id}`,
                    }}
                  />
                )}
                {activeTab === 3 && <AppraisalTab historyId={historyId} />}
                {activeTab === 4 && (
                  <PropertyAssessmentTab historyId={historyId} />
                )}
                {activeTab === 5 && (
                  <SupersededAssessmentTab historyId={historyId} />
                )}
                {activeTab === 6 && <TransactionTab historyId={historyId} />}
              </div>
            </>
          ) : (
            <div className="d-flex align-items-center justify-content-center h-100">
              <div className="text-center mx-auto py-4">
                <img
                  src={emptyStateImage}
                  className="img-responsive image-wrapper mb-4 mt-3"
                  alt="Empty State"
                />
                <p className="emp-title mb-0">No Item Found</p>
              </div>
            </div>
          )}
        </div>
        <div className="col-12 d-flex justify-content-center">
          <button
            type="button"
            onClick={closeModal}
            className="btn button-close "
          >
            <span className="font-weight-bold">Close</span>
          </button>
        </div>
      </div>
    </Modal.Body>
  );
}

ViewHistoryModal.propTypes = {
  applicationId: PropTypes.string.isRequired,
  historyId: PropTypes.string.isRequired,
  getSingleHistory: PropTypes.instanceOf(Object).isRequired,
  singleHistoryData: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => {
  return {
    singleHistoryData: _.get(api, `${c.GET_SINGLE_HISTORY}.item`) || {},
  };
};

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(ViewHistoryModal);
